export default {
	['@cartaction.window']() {
		switch (this.$event.detail.action) {
			case 'insert-item':
				this.itemInsertionId = this.$event.detail.data.id || null;
				this.itemInsertionSubproductId =
					this.$event.detail.data.subproductId || null;
				if (this.itemInsertionId === null) {
					throw new Error(
						'insert-item action called with no item id'
					);
				}
				if (!this.cartState?.selectedConfigurationId) {
					this.$dispatch('modalopenid', {
						modalid: 'first-addition-modal',
					});
				} else {
					if (
						(this.cartState?.configurationStates?.localCartState ||
							null) === null
					) {
						throw new Error(
							'localCartState is not initialized. This is a bug. Please refresh the page.'
						);
					}
					this.cartState.configurationStates.localCartState.push({
						id: this.itemInsertionId,
						subproductId: this.itemInsertionSubproductId || null,
					});
					this.fetchAllProductData();
					this.$dispatch('modalopenid', {
						modalid: 'cart-modal',
					});
				}
				break;
			case 'delete-item-confirmed':
				if (this.itemToBeRemoved !== null) {
					this.deleteItem(this.itemToBeRemoved);
					this.itemToBeRemoved = null;
				} else {
					throw new Error('No item id was set for deletion.');
				}
				break;
			case 'open-delete-modal':
				if (
					this.$event.detail?.data?.index !== null &&
					this.$event.detail?.data?.index !== undefined
				) {
					this.itemToBeRemoved = this.$event.detail.data.index;
					this.$dispatch('modalopenid', {
						modalid: 'delete-confirmation-modal',
					});
				} else {
					throw new Error('No item id provided for deletion.');
				}
				break;
			case 'open-create-new-configuration':
				this.openCreateNewConfiguration();
				break;
			case 'create-new-configuration':
				this.createNewConfiguration();
				break;
			case 'create-new-empty-configuration':
				this.firstInsertCartState = null;
				this.firstInsertCartItemInfo = null;
				this.createNewConfiguration();
				break;
			case 'save-configuration':
				this.saveCurrentConfiguration();
				break;
			case 'insert-item-into-new':
				this.insertItemIntoNew();
				break;
			case 'insert-item-into-existing':
				this.$dispatch('modalopenid', {
					modalid: 'select-configuration-modal',
				});
				break;
			case 'modal-close-confirmed':
				this.modalCloseConfirmed(this.modalToBeClosedId);
				this.modalToBeClosedId = null;
				break;
			case 'configuration-switch-confirmed':
				this.setSelectedConfigurationId(this.configurationToBeSelected);
				this.configurationToBeSelected = null;
				this.itemConfigurationOpen = -1;
				break;
			case 'refresh-all-configurations':
				this.fetchAllConfigurations();
				break;
			case 'pre-select-offer':
				if ((this.$event.detail.data?.newid || null) !== null) {
					this.preSelectedOfferId = this.$event.detail.data?.newid;
				}
				break;
			case 'select-offer':
				this.setSelectedConfigurationId(this.preSelectedOfferId);
				this.$dispatch('modalcloseid', {
					modalid: 'select-configuration-modal',
				});
				this.preSelectedOfferId = null;
				break;
			case 'change-offer':
				const newid = this.$event?.detail?.data?.newid || null;
				if (newid !== null) {
					if (
						(this.cartState?.configurationStates || null) !== null
					) {
						if (this.isConfigurationStateSameOnServer()) {
							this.setSelectedConfigurationId(newid);
						} else {
							this.configurationToBeSelected = newid;
							this.$dispatch('modalopenid', {
								modalid: 'switch-confirmation-modal',
							});
						}
					} else {
						throw new Error(
							'When calling change-offer there must be a valid selectedConfigurationId present.'
						);
					}
				} else {
					throw new Error(
						"The change-offer cart action has to have a non-falsy data value named 'newid'."
					);
				}
				break;
			case 'open-cart-from-header':
				if (this.cartState === null) {
					throw new Error(
						'The cart state has to be initialized first to open a cart'
					);
				}
				if (this.cartState.selectedConfigurationId === null) {
					this.itemInsertionId = null;
					this.itemInsertionSubproductId = null;
					this.$dispatch('modalopenid', {
						modalid: 'new-empty-cart-modal',
					});
				} else {
					this.$dispatch('modalopenid', {
						modalid: 'cart-modal',
					});
				}
				break;
			case 'send-via-email':
				this.sendViaEmail();
				break;
			case 'send-via-email-first-insert':
				this.sendViaEmailFirstInsert();
				break;
			case 'reload-cartitemsinfo':
				this.fetchAllProductData();
				break;
			case 'reload-firstinsert-cartitemsinfo':
				this.loadFirstInsertCartItemsInfo();
				break;
			case 'save-product-configuration-changes':
				this.saveProductConfigurationChanges(
					this.itemConfigurationOpen
				);
				break;
			case 'save-product-configuration-changes-first-insert':
				this.saveProductConfigurationChangesFirstInsert();
				break;
			case 'delete-in-first-insertion-modal':
				this.$dispatch('modalcloseid', {
					modalid: 'new-cart-modal',
				});
				this.$nextTick(() => {
					this.firstInsertCartState = null;
					this.firstInsertCartItemInfo = null;
					this.$dispatch('modalopenid', {
						modalid: 'new-empty-cart-modal',
					});
				});
				break;
			case 'download-pdf':
				this.saveCurrentConfiguration().then(
					this.downloadLatestPdf.bind(this)
				);
				break;
			case 'download-pdf-first-insert':
				this.createNewConfiguration().then(
					this.downloadLatestPdf.bind(this)
				);
				break;
			case 'send-via-email-modal':
				this.saveCurrentConfiguration().then(
					this.openSendEmailModal.bind(this)
				);
				break;
			case 'send-via-email-first-insert-modal':
				this.createNewConfiguration().then(
					this.openSendEmailModal.bind(this)
				);
				break;
			default:
				console.warn(
					`Cart action ${this.$event.detail.action} is not implemented yet.`
				);
		}
	},
};
